import React from 'react';
import parse from 'html-react-parser';

export default function OptionLabel({
  label,
  labelTooltip
}) {
  return label && (
    <div className="app-option-name">
      {parse(label)}
      {labelTooltip && (<span className="app-option-tooltip"><span className="app-option-tooltip-text">{parse(labelTooltip)}</span></span>)}
    </div>
  )
};
